import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { decode } from '@finn-no/safe-props';
import TopBarWithTracking from './topbar-with-tracking.js';

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('bc-topbar-root');

    if (rootElement && rootElement.dataset.props) {
        hydrateRoot(
            rootElement,
            <TopBarWithTracking {...decode(rootElement.dataset.props)} />,
        );
    }
    // Fallback
    else if (rootElement) {
        hydrateRoot(rootElement, <TopBarWithTracking hideMenu />);
        console.warn('business-center-topbar renders fallback');
    }
});
